export default class ShareAction {

    static init() {
        const shareButtons = document.querySelectorAll('.share__buttons');
        const toggleButtons = document.querySelectorAll('.share__open-btn');

        if (shareButtons && toggleButtons) {
            let delay = 200;
            let open = false;
            let curStep = 0;

            const setStep = (curStep) => {
                shareButtons.forEach((shareButton) => {
                    shareButton.classList.remove('step-1', 'step-0', 'step-2');
                    shareButton.classList.add('step-' + curStep);
                });
            };

            let lastTimeout;

            const animate = () => {
                if (curStep >= 3) {
                    curStep = 0;
                    return;
                }

                open = true;
                setStep(curStep);
                curStep++;
                lastTimeout = setTimeout(animate, delay);
            };

            toggleButtons.forEach((toggleButton) => {
                toggleButton.addEventListener('click', () => {
                    if (! open) {
                        animate();
                    } else {
                        shareButtons.forEach(($button) => {
                            $button.classList.remove('step-1', 'step-0', 'step-2');
                        });
                        clearTimeout(lastTimeout);
                        open = false;
                        curStep = 0;
                    }
                });
            });
        }
    }
}
